<div mat-dialog-title class="fx-layout-row fx-align--x-center">
  <h2 [innerHtml]="productCategory?.title"></h2>
  <div class="fx-flex-grow"></div>
  <button mat-icon-button color="secondary" mat-dialog-close tabindex="-1">
    <mat-icon svgIcon="x"></mat-icon>
  </button>
</div>

<mat-dialog-content>
  @if (productCategory.type !== 'MAT' && productCategory.type !== 'SIZE-SELECTOR') {
    <mbnm-product-selector [productCategory]="productCategory" #productSelector
      (availableProductsChanged)="availableProductsChanged($event)"
      [selectedProducts]="productCategory.selection"
      [cols]="productCategory.cols" [mobile-cols]="productCategory.mobileCols"
      (change)="onSelectedProductChange($event, productCategory)"
      [noProductsAvailableMessage]="productCategory.noProductsAvailableMessage"
      [activeGroupName]="productCategory.filteredProductsGroupName"
      [samplesMode]="samplesMode">
    </mbnm-product-selector>
  }
  @if (productCategory.type == 'MAT') {
    <mbnm-mat-selector
      [project]="project" [productCategory]="productCategory"
      (change)="onSelectedProductChange($event, productCategory)"
      (availableProductsChanged)="availableProductsChanged($event)"
      [selectedProducts]="productCategory.selection"
      [activeGroupName]="productCategory.filteredProductsGroupName"
      [layers]="productCategory.layers"
      [samplesMode]="samplesMode"
      #matSelector>
    </mbnm-mat-selector>
  }
  @if (productCategory.type == 'SIZE-SELECTOR') {
    <mbnm-builder-size-selector [tileData]="sizeHelpInfo"
      #sizeSelector [project]="project" [secondary]="true">
    </mbnm-builder-size-selector>
  }
</mat-dialog-content>

<mat-dialog-actions class="fx-column-row fx-align--space-between-x fx-layout-wrap fx-gap--16px">
  @if (samplesMode && productCategory.products.length > 1) {
    <div class="fx-flex--100">
      @if (samplesMode) {
        <mat-checkbox labelPosition="before" disableRipple="true" [(ngModel)]="selectAll" (change)="toggleSelectAll()">
          Select All
        </mat-checkbox>
      }
    </div>
  }
  @if (productCategory.type == 'SIZE-SELECTOR' || samplesMode) {
    <button mat-flat-button color="primary" [mat-dialog-close]="true" (click)="saveChanges()">
      Save
    </button>
    <button mat-flat-button mat-dialog-close color="secondary" (click)="revertChanges()">
      Cancel
    </button>
  }

  @if (!samplesMode && showSamplesButton) {
    <div></div>
    <button mat-flat-button color="secondary" (click)="showSamplesDialog()">
      Need Samples?
    </button>
  }

  @if (specialInstructions) {
    <div class="special-instructions" [innerHtml]="specialInstructions">
    </div>
  }

</mat-dialog-actions>
